<template>
    <div>
        <admin-template>
            <div class="mb-4" v-if="licenceExpired">
                <div class="bg-red-100 text-red-700 px-4 py-6 rounded mb-4 font-bold text-xl">
                    <i class="fas fa-exclamation-triangle mr-2"></i> Licence expirée
                </div>
            </div>
            <div class="grid grid-cols-12">
                <!-- Left menu -->
                <div class="col-span-3 px-4">
                    <div class="space-y-0.5">
                        <button @click="selectedComponent = 'AdminSocieteConnexion'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteConnexion' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-lock mr-1"></i> Connexions
                        </button>
                        <!-- <button @click="selectedComponent = 'AdminSocieteGeneral'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteGeneral' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-building mr-1"></i> Société
                        </button> -->
                        <!-- <button @click="selectedComponent = 'AdminSocieteUsers'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteUsers' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-users mr-1"></i> Utilisateurs
                        </button> -->
                        <button @click="selectedComponent = 'AdminSocieteSubscription'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteSubscription' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-euro mr-1"></i> Abonnement
                        </button>
                        <button @click="selectedComponent = 'AdminSocieteSMS'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteSMS' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-sms mr-1"></i> SMS
                        </button>
                        <!-- <button @click="selectedComponent = 'AdminSocieteInterventions'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteInterventions' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-calendar-alt mr-1"></i> Interventions
                        </button> -->
                        <!-- <button @click="selectedComponent = 'AdminSocieteDocuments'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteDocuments' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-file mr-1"></i> Documents
                        </button> -->
                        <!-- <button @click="selectedComponent = 'AdminSocieteCommunication'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteCommunication' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-comments mr-1"></i> Communication
                        </button> -->
                        <!-- <button @click="selectedComponent = 'AdminSocieteStock'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteStock' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-warehouse mr-1"></i> Stock
                        </button> -->
                        <!-- <button @click="selectedComponent = 'AdminSocieteBouteilles'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteBouteilles' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-bottle-water mr-1"></i> Bouteilles
                        </button> -->
                        <button @click="selectedComponent = 'AdminSocieteContact'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteContact' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-comment mr-1"></i> Contacter
                        </button>
                        <button @click="selectedComponent = 'AdminSocieteAccesRestreint'" class="text-left w-full text-sm block p-3 rounded-lg transition-colors" :class="selectedComponent === 'AdminSocieteAccesRestreint' ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-slate-200 hover:text-black'">
                            <i class="fas fa-ban mr-1"></i> Accès restreint
                        </button>
                    </div>
                </div>

                <!-- Main content -->
                <div class="col-span-9 p-4 bg-white rounded-lg shadow min-h-[80vh]">
                    <component :is="selectedComponent" />
                </div>
            </div>
        </admin-template>
    </div>
</template>

<script>
import AdminSocieteConnexion from './Components/AdminSocieteConnexion.vue';
import AdminSocieteGeneral from './Components/AdminSocieteGeneral.vue';
import AdminSocieteUsers from './Components/AdminSocieteUsers.vue';
import AdminSocieteSubscription from './Components/AdminSocieteSubscription.vue';
import AdminSocieteSMS from './Components/AdminSocieteSMS.vue';
import AdminSocieteContact from './Components/AdminSocieteContact.vue';
import AdminSocieteAccesRestreint from './Components/AdminSocieteAccesRestreint.vue';

export default {
    components: {
        AdminSocieteGeneral,
        AdminSocieteUsers,
        AdminSocieteSubscription,
        AdminSocieteSMS,
        AdminSocieteConnexion,
        AdminSocieteContact,
        AdminSocieteAccesRestreint,
    },

    data() {
        return {
            selectedComponent: 'AdminSocieteConnexion'
        }
    },

    computed: {
        licenceExpired() {
            if (this.$account.account.societe.date_licence) {
                let expiryDate = moment(this.$account.account.societe.date_licence);
                let now = moment();
                return now.isAfter(expiryDate);
            }
            return false;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>